import type { FaireProductEntity } from "../../entity_types/product";

export const p_6k3tqx8vu7: FaireProductEntity = {
  token: "p_6k3tqx8vu7",
  type: "product",
  name: "LACE POLKA DOT MINI DRESS",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/d02bbd0e7a4b0cc5190ea6ad13d9ab5fefd84a849a1f0853a7b5987245363a33.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/82a1670a8ba9c0adb4696058c596671dce5b94d99005edc71ae140be5ce2e25b.jpeg",
    "https://cdn.faire.com/fastly/d085f2f130a5ef9f31f07d161431299246d4a8f0b7bb57b15a5c231daaa14511.jpeg",
    "https://cdn.faire.com/fastly/2c49071f7a2188a3b8a1485f1651469a5d039200d111c073172423192412c6a2.jpeg",
  ],
  priceDollars: 216,
  description:
    'Model is wearing a size small.\n\n𝐌𝐨𝐝𝐞𝐥 𝐬𝐩𝐞𝐜𝐬\n• Height: 5\'8"\n• Bust: 32A\n• Waist: 24"\n• Hips: 34"',
  tags: [],
  msrpDollars: 432,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:15.212Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
